import Vue from "vue";
import { Loading, Carousel, carouselItem, Button, Input, Select, Upload, Icon, Progress, DatePicker, Radio, Form, Avatar, Empty, Message } from "element-ui";

//给全局的Vue对象注册组件
Vue.use(Loading, Carousel, carouselItem, Button, Input, Select, Upload, Icon, Progress, DatePicker, Radio, Form, Avatar, Empty, Message);
